import PropTypes from 'prop-types'
import { gql } from '@apollo/client'
import { eventListFragment, eventListFragmentPropTypes } from '~/graphql/fragments/eventList'

const recurringEventCollection = gql`
  fragment recurringEventCollection on RecurringEventCollection {
    id
    type
    status
    title
    subtitle
    numberOfEventsOnFeedOverview: numbersOfEventsOnFeedOverview
    events {
      edges {
        node {
          ...eventList
        }
      }
    }
  }

  ${eventListFragment}
`

export const recurringEventCollectionPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'THUMBNAIL_EVENT_COLLECTION',
    'THUMBNAIL_WITH_URL',
    'THUMBNAIL_BLOG',
    'GROUP_COLLECTION',
    'RECURRING_EVENT_COLLECTION',
    'RECOMMENDED_EVENT_COLLECTION',
  ]).isRequired,
  status: PropTypes.oneOf(['ACTIVE', 'PREVIEW']).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  numberOfEventsOnFeedOverview: PropTypes.number.isRequired,
  events: PropTypes.shape({
    edges: PropTypes.arrayOf(
      PropTypes.shape({
        node: eventListFragmentPropTypes,
      })
    ),
  }),
})

export default recurringEventCollection
